import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinBy',
  standalone: true
})
export class JoinByPipe implements PipeTransform {
  transform<T>(items: T[] | null | undefined, key: keyof T, separator: string = ', '): string {
    if (!items?.length) {
      return '';
    }

    return items
      .map((item) => item[key])
      .filter(Boolean)
      .join(separator);
  }
}
